import styled from 'styled-components';

export const Container = styled.div`
  & > label {
    width: 176px;
    padding: 10px 8px;
    height: inherit;
    margin-bottom: 0;
    gap: 7px;

    & > svg {
      min-height: 12px;
      min-width: 12px;
      margin: 0;

      &:first-child {
        margin: 0;
      }
    }

    & select {
      margin: 0;
      font-size: 12px;
      line-height: 19px;
    }
  }
`;
